import {
  AddFavoriteMutation,
  AddFavoriteMutationVariables,
  DeleteFavoriteMutation,
  DeleteFavoriteMutationVariables,
  Enum_Favorite_Type,
  ExistByRelationIdQuery,
  ExistByRelationIdQueryVariables,
  FavoriteInput,
  FavoritesPageableByUserIdQuery,
  FavoritesPageableByUserIdQueryVariables,
  FavouritePageQuery,
  FavouritePageQueryVariables,
  FetchPodcastsByIdsQuery,
  FetchPodcastsByIdsQueryVariables,
  FetchResourcesByIdsQuery,
  FetchResourcesByIdsQueryVariables,
  FindByRelationIdQuery,
  FindByRelationIdQueryVariables,
} from '@/graphql/generated/graphql';
import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import { getAuthentication } from '@/hooks/useAuthentication';

import {
  QUERY_EXIST_FAVORITE,
  QUERY_FAVORITES,
  QUERY_FAVORITE_PAGE,
  QUERY_FIND_FAVORITE,
} from '@/graphql/queries/favorite/favorite';
import { QUERY_FETCH_PODCASTS_BY_IDS } from '@/graphql/queries/favorite/favorite-podcast';
import { QUERY_FETCH_RESOURCES_BY_IDS } from '@/graphql/queries/favorite/favorite-resource';
import { MUTATION_ADD_FAVORITE, MUTATION_DELETE_FAVORITE } from '@/graphql/mutations/favorite/create';

export const fetchUserFavorites = async (type: Enum_Favorite_Type, size: number) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<FavoritesPageableByUserIdQuery, FavoritesPageableByUserIdQueryVariables>({
      query: QUERY_FAVORITES,
      variables: {
        type,
        size,
        userId: getAuthentication()?.user?.id,
      },
    }),
  );

  if (error) {
    console.error(error);
    return { data: null };
  }

  return { data };
};

export const fetchPodcastsByIds = async (ids: string[]) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<FetchPodcastsByIdsQuery, FetchPodcastsByIdsQueryVariables>({
      query: QUERY_FETCH_PODCASTS_BY_IDS,
      variables: {
        ids,
      },
    }),
  );

  if (error) {
    console.error(error);
    return { data: null };
  }

  return { data };
};

export const fetchResourcesByIds = async (ids: string[]) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<FetchResourcesByIdsQuery, FetchResourcesByIdsQueryVariables>({
      query: QUERY_FETCH_RESOURCES_BY_IDS,
      variables: {
        ids,
      },
    }),
  );

  if (error) {
    console.error(error);
    return { data: null };
  }

  return { data };
};

export const addFavorite = async (input: FavoriteInput) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.mutate<AddFavoriteMutation, AddFavoriteMutationVariables>({
      mutation: MUTATION_ADD_FAVORITE,
      variables: {
        data: input,
      },
    }),
  );

  if (error) {
    console.error(error);
    return { data: null };
  }

  return { data };
};

export const removeFavorite = async (id: string) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.mutate<DeleteFavoriteMutation, DeleteFavoriteMutationVariables>({
      mutation: MUTATION_DELETE_FAVORITE,
      variables: {
        id,
      },
    }),
  );

  if (error) {
    console.error(error);
    return { data: null };
  }

  return { data };
};

export const existFavorite = async (relationId: string) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<ExistByRelationIdQuery, ExistByRelationIdQueryVariables>({
      query: QUERY_EXIST_FAVORITE,
      variables: {
        relationId: parseInt(relationId),
        userId: getAuthentication()?.user?.id,
      },
    }),
  );

  if (error) {
    console.error(error);
    return { data: null };
  }

  return { data };
};

export const findFavorite = async (relationId: string) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<FindByRelationIdQuery, FindByRelationIdQueryVariables>({
      query: QUERY_FIND_FAVORITE,
      variables: {
        relationId: parseInt(relationId),
        userId: getAuthentication()?.user?.id,
      },
    }),
  );

  if (error) {
    console.error(error);
    return { data: null };
  }

  return { data };
};

export const fetchFavouritePage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<FavouritePageQuery, FavouritePageQueryVariables>({
      query: QUERY_FAVORITE_PAGE,
      fetchPolicy: 'cache-first',
    }),
  );

  if (error) {
    console.error(error);
    return { data: null };
  }

  return { data };
};
